import { Alert, AlertTitle, Box } from "@mui/material";
import { ResponsiveRow } from "../constants/layout.constants";

import personal_details_screen from "../images/unauthorized_faq/personal_details_screen.png";
import company_details from "../images/unauthorized_faq/company_details.png";
import property_details from "../images/unauthorized_faq/property_details.png";
import subscription_plans from "../images/unauthorized_faq/subscription_plans.png";
import payment_integration_options from "../images/unauthorized_faq/payment_integration_options.png";
import utilities_support from "../images/unauthorized_faq/utilities_support.png";
import details_manually from "../images/unauthorized_faq/details_manually.png";
import upload_template from "../images/unauthorized_faq/upload_template.png";
import quick_row_entry from "../images/unauthorized_faq/quick_row_entry.png";
import quick_row_entry_utilities from "../images/unauthorized_faq/quick_row_entry_utilities.png";
import checkbox_driven_entry from "../images/unauthorized_faq/checkbox_driven_entry.png";
import checkbox_driven_entry_utilities from "../images/unauthorized_faq/checkbox_driven_entry_utilities.png";
import add_lease_modal from "../images/unauthorized_faq/add_lease_modal.png";
import lease_charges from "../images/unauthorized_faq/lease_charges.png";
import review_details from "../images/unauthorized_faq/review_details.png";
import verify_phone_number from "../images/unauthorized_faq/verify_phone_number.png";

export default class UnauthorizedFaqLoader {
  constructor() {
    this.faqData = [
      {
        name: "selfSignUp",
        text: "How do I complete the self sign-up process?",
        data: [
          {
            hasSubAnswers: true,
            hasSteps: false,
            hasDescription: true,
            questionID: 1,
            question: "STEP 1: PERSONAL DETAILS",
            answer: "You must provide the following details: First Name, Last Name, Mobile Phone (Primary Number), ID Type (National ID, Passport, etc.), ID Number, Email Address.",
            subAnswers: [
              {
                header: "Personal Details",
                steps: [
                  `a. You must provide the following details: `,
                  () => {
                    return (
                      <Box
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <ul>
                          <li>First Name</li>
                          <li>Last Name</li>
                          <li>Mobile Phone (Primary Number)</li>
                          <li>ID Type (National ID, Passport, etc.)</li>
                          <li>ID Number</li>
                          <li>Email Address</li>
                        </ul>
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={personal_details_screen}
                          alt="personal details screen"
                        />
                      </Box>
                    );
                  },
                  `b. Optional fields include:`,
                  () => {
                    return (
                      <>
                        <ResponsiveRow
                          sx={{
                            margin: "0px auto",
                            width: { xs: "100%", lg: "90%" },
                            padding: "0 10px",
                          }}
                        >
                          <ul>
                            <li>Middle Name</li>
                            <li>Office Phone (secondary number)</li>
                            <li>
                              Checkbox: “Is your property owned or managed under
                              a company/organization name?”
                            </li>
                          </ul>
                        </ResponsiveRow>
                        <Alert severity="info">
                          <AlertTitle>Note</AlertTitle>
                          <p style={{ fontWeight: 600, fontStyle: "italic" }}>
                            Note: This does not refer to an external property
                            management agency. Select this option only if your
                            property is owned or registered under a
                            company/organization name. If you personally own and
                            manage your property as an individual, do not check
                            this option.
                          </p>
                        </Alert>
                      </>
                    );
                  },
                ],
              },
              {
                header: "Company Details",
                steps: [
                  `c. What happens if I check “Is your property managed by an organization/company?”`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "0px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "0px 10px",
                        }}
                      >
                        <p>
                          Additional required fields will appear:
                          <br />
                          <strong>&bull; Company Name</strong>
                          <br />
                          <strong>&bull; Address 1</strong>
                          <br />
                          <strong>&bull; Country</strong>
                          <br />
                          <strong>&bull; City</strong>
                          <br />
                          Optional: <strong>&bull; Address 2</strong>{" "}
                          <strong>&bull; Description</strong>{" "}
                          <strong>&bull; Tax ID</strong>
                        </p>
                      </ResponsiveRow>
                    );
                  },
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "10px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "10px",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            margin: "10px 5px",
                            objectFit: "cover",
                            objectPosition: "center",
                            borderRadius: "10px",
                          }}
                          src={company_details}
                          alt="company details"
                        />
                      </ResponsiveRow>
                    );
                  },
                ],
              },
              {
                header: "Navigation Buttons",
                steps: [
                  `d. What navigation buttons are available in this step?`,
                  () => {
                    return (
                      <ResponsiveRow
                        sx={{
                          margin: "0px auto",
                          width: { xs: "100%", lg: "90%" },
                          padding: "0 10px",
                        }}
                      >
                        <ul>
                          <li>
                            <strong>Save & Continue</strong> → Go to the next
                            step (Property Details)
                          </li>
                          <li>
                            <strong>Save & Finish Later</strong> → Pause signup
                            and continue later
                          </li>
                          <li>
                            <strong>Resume Sign Up</strong> → Pick up from where
                            you left off using your phone/email
                          </li>
                        </ul>
                      </ResponsiveRow>
                    );
                  },
                ],
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            questionID: 2,
            question: "STEP 2: PROPERTY DETAILS",
            answer: "Provide the details of the property you would like to manage through SmartKodi",
            steps: [
              `a. What property information do I need to provide?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <ul>
                      <li>
                        <strong>Property Name</strong>*
                      </li>
                      <li>
                        <strong>Country</strong>*
                      </li>
                      <li>
                        <strong>Address</strong>
                      </li>
                      <li>
                        <strong>City</strong>
                      </li>
                      <li>
                        Optional:{" "}
                        <strong>LR Number, Latitude & Longitude</strong>
                      </li>
                    </ul>
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={property_details}
                      alt="property details"
                    />
                  </ResponsiveRow>
                );
              },
              `b. Do I need to select a subscription plan now?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <p>
                      <strong>
                        Yes. You must choose a Subscription Plan (e.g., Premium,
                        Core).
                      </strong>{" "}
                      To see the features and benefits of each plan, check out
                      our{" "}
                      <a
                        href="https://www.smartkodi.co.ke/index.html#pricing"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <strong>Pricing Page</strong>
                      </a>
                      .
                    </p>
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={subscription_plans}
                      alt="subscription plans"
                    />
                  </ResponsiveRow>
                );
              },
              `c. Can I set up payment integrations during signup?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <div>
                      <strong>
                        Yes. During signup, you can choose to enable the
                        following:
                      </strong>
                      <ul
                        style={{ listStyleType: "disc", paddingLeft: "20px" }}
                      >
                        <li>M-Pesa Integration</li>
                        <li>Bank Payment Integration</li>
                      </ul>
                    </div>
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={payment_integration_options}
                      alt="payment integration options"
                    />
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <p>
                      For <strong>Core</strong> and <strong>Lean</strong>{" "}
                      subscriptions, you can also configure{" "}
                      <strong>Utilities Support</strong>. To learn more about
                      what’s included in each subscription, check out our{" "}
                      <a
                        href="https://www.smartkodi.co.ke/index.html#pricing"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <strong>Pricing Page</strong>
                      </a>
                    </p>
                  </ResponsiveRow>
                );
              },
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={utilities_support}
                      alt="utilities support"
                    />
                  </ResponsiveRow>
                );
              },
              `d. How do I add my units, residents and meter details?`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <p>You can choose to:</p>
                    <p>i. Enter details manually</p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={details_manually}
                      alt="manually"
                    />
                    <p>
                      ii. Use the bulk upload Excel template. Once you download,
                      fill out and upload the template, your units, meters and
                      residents details will automatically be prefilled in the
                      next steps of the signup process.
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={upload_template}
                      alt="upload template"
                    />
                    <Alert severity="info" style={{ margin: "10px 0px" }}>
                      Note: You can only upload one property during the
                      self-sign-up process. Once you have successfully completed
                      the sign-up and logged in, you will be able to add more
                      properties or buildings you want to manage.
                    </Alert>
                  </Box>
                );
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            questionID: 2,
            question: "STEP 3: UNIT DETAILS",
            answer: "Provide the details of the units within your property property",
            steps: [
              `a. You can add unit details manually through two ways: `,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <p>
                      <b>i. Quick Row Entry</b> - Fill all details in a row
                      directly
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={quick_row_entry}
                      alt="quick row entry"
                    />
                    <p>
                      <b>ii. Checkbox-Driven Entry </b> – Select which fields
                      you want to fill in.
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={checkbox_driven_entry}
                      alt="checkbox driven entry"
                    />
                  </ResponsiveRow>
                );
              },
              `b. What details can I add for each unit?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>Unit Type</li>
                      <li>Square Meters</li>
                      <li>Rent Per Square Meter</li>
                      <li>Beds, Baths</li>
                      <li>Rent</li>
                      <li>Unit Name (e.g., 1A, B2)</li>
                    </ul>
                  </ResponsiveRow>
                );
              },
              `c. How do I manage Units?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>
                        Click <b>Add Unit</b> to add more.
                      </li>
                      <li>
                        Click the <b>red X</b> to remove a unit.
                      </li>
                    </ul>
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            questionID: 4,
            question: "STEP 4: UTILITY DETAILS",
            answer: "Provide the details of the utilities in your property",
            steps: [
              `a. You can add utility details manually through two ways: `,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <p>
                      <b>i. Quick Row Entry</b> - Fill all details in a row
                      directly
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={quick_row_entry_utilities}
                      alt="quick row entry"
                    />
                    <p>
                      <b>ii. Checkbox-Driven Entry </b> – Tick fields (Rate
                      Type, Standing Charge, etc.) to reveal inputs.
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={checkbox_driven_entry_utilities}
                      alt="checkbox driven entry"
                    />
                  </ResponsiveRow>
                );
              },
              `b. What utility fields can I add?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>Reading Frequency</li>
                      <li>Meter Type</li>
                      <li>Rate Type (Fixed, Tiered)</li>
                      <li>Standing Charge (If applicable)</li>
                      <li>Rate</li>
                      <li>Name</li>
                      <li>Linked Unit</li>
                      <li>Frequency (Daily, Weekly, Monthly)</li>
                      <li>
                        Invoiced? Check this if the meter is to be invoiced to
                        the occupant
                      </li>
                      <li>Taxed (Yes/No)</li>
                      <li>Tiered Rates</li>
                    </ul>
                  </ResponsiveRow>
                );
              },
              `c. Can I remove utilities?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>
                        Click the <b>red X</b> to remove a utility before
                        saving.
                      </li>
                    </ul>
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            questionID: 5,
            question: "STEP 5: RESIDENT DETAILS",
            answer: "Provide the details of the Residents within your property",
            steps: [
              `a. How do I link units to residents manually?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <p>
                      Click <b>Add</b> button to add leases tied to units.
                    </p>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={add_lease_modal}
                      alt="add lease modal"
                    />
                  </ResponsiveRow>
                );
              },
              `b. What information is required for a new lease?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>Lease Terms (Fixed or At will)</li>
                      <li>Start Date</li>
                      <li>Lease Type (Residential or Commercial)</li>
                      <li>Tenant (select or add new)</li>
                      <li>Rent Frequency</li>
                      <li>Unit(s)</li>
                    </ul>
                  </ResponsiveRow>
                );
              },
              `c. Can I add Lease Charges?`,
              () => {
                return (
                  <Box
                    sx={{
                      margin: "0px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "0 10px",
                    }}
                  >
                    <p>
                      Yes, and for each lease charge, provide the following:
                    </p>
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>Select Unit</li>
                      <li>Charge Type (Rent, Deposit, etc.)</li>
                      <li>Amount</li>
                      <li>Start Date</li>
                      <li>Taxed (Yes/No)</li>
                    </ul>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={lease_charges}
                      alt="lease charges"
                    />
                  </Box>
                );
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: true,
            hasDescription: true,
            questionID: 6,
            question: "STEP 6: REVIEW DETAILS",
            answer: "Review the details registered for the property",
            steps: [
              `a. What information do I need to review?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>
                        <b>1. Subscriber Information</b> – Name, Email, and
                        Phone (must be verified).
                      </li>
                      <li>
                        <b>2. Subscription Information</b> – Subscription type,
                        units, cost.
                      </li>
                      <li>
                        <b>3. Unit & Charge Details</b> – Tenant names, unit
                        names, billing codes, charges.
                      </li>
                    </ul>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={review_details}
                      alt="review details"
                    />
                  </ResponsiveRow>
                );
              },
              `b. How do I verify my phone number?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                      <li>
                        Click <b>Verify Phone Number</b> to send a text message
                        to your phone number.
                      </li>
                      <li>Enter the 6-digit SMS code (valid for 2 minutes).</li>
                    </ul>
                    <img
                      style={{
                        maxWidth: "100%",
                        margin: "10px 5px",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "10px",
                      }}
                      src={verify_phone_number}
                      alt="verify phone number"
                    />
                  </ResponsiveRow>
                );
              },
              `c. How do I complete signup?`,
              () => {
                return (
                  <ResponsiveRow
                    sx={{
                      margin: "10px auto",
                      width: { xs: "100%", lg: "90%" },
                      padding: "10px",
                    }}
                  >
                    <p>
                      Click <b>Get Started</b>. Your subscription will be
                      activated.
                    </p>
                  </ResponsiveRow>
                );
              },
            ],
          },
          {
            hasSubAnswers: false,
            hasSteps: false,
            hasDescription: true,
            questionID: 7,
            question: "What are the minimum charges?",
            answer: "If the calculated amount is below the threshold, it defaults to KSh 2,000.00.",
          }
        ],
      },
    ];
  }

  getFAQData() {
    return this.faqData;
  }

  mapQuestionsToArray() {
    const questionsArray = [];
    let count = 0;
    this.faqData.map((data) => {
      return data.data.forEach((question_item) => {
        count++;
        questionsArray.push({
          id: count,
          label: question_item.question,
          section: data.name,
        });
      });
    });

    return questionsArray;
  }
}
